import Button from "components/Button";
import styled, { css } from "styled-components";
import theme from "theme";

export const Wrapper = styled.div`
    display: grid;
    grid-template-areas:
        "header header"
        "sidenav  main";
    grid-template-rows: auto 80dvh;
    grid-template-columns: 325px 1fr;
    grid-row-gap: 7rem;
    background: var(--b-wf-9-f-9-f-9, #f9f9f9);
    padding-bottom: 2rem;

    @media (${theme.breakpoints.tabletL}) {
        grid-template-columns: 280px 1fr;
    }

    @media (${theme.breakpoints.mobileL}) {
        grid-template-areas:
            "main"
            "sidenav";
        grid-template-columns: unset;
        grid-template-rows: unset;
        padding-bottom: unset;
    }
`;

export const Right = styled.div`
    grid-area: main;
    margin: 0 14px;
    border-radius: 24px;
    position: relative;
    height: 100%;
    background-color: ${theme.colors.white};
    padding: 16px 14px;
    /* overflow-y: scroll; */

    @media (${theme.breakpoints.mobileL}) {
        margin-top: 6.5rem;
    }
`;

export const Header = styled.div`
    ${theme.mixins.flexBetween};
    align-items: center;
    padding-right: 1rem;
`;

export const HeaderText = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 0.3rem;
`;
export const CountsWrapper = styled.div`
    ${theme.mixins.flexCenter};

    .resultsText {
        margin-left: 0.3rem;
    }
`;

export const Body = styled.div`
    margin: 1.2rem 0;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 1rem;
    row-gap: 2rem;
    overflow-y: scroll;
    height: 66dvh;
    padding-right: 1rem;

    @media (${theme.breakpoints.desktopS}) {
        grid-template-columns: 1fr 1fr;
    }

    @media (${theme.breakpoints.mobileL}) {
        height: 100%;
        grid-template-columns: 1fr;
        padding: 0;
        padding-bottom: 6rem;
    }
`;

export const TalentCardWrapper = styled.div<{ isFlipped: boolean }>`
    width: 100%;
    height: 300px;
    perspective: 1000px;
    > div {
        transform: ${({ isFlipped }) =>
            isFlipped ? "rotateY(180deg)" : "rotateY(0)"};
        transition: transform 0.6s;
        transform-style: preserve-3d;
        position: relative;
    }
`;
export const CardInner = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
`;

export const CardFront = styled.div`
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    position: absolute;
    top: 0;
    left: 0;
`;
export const CardBack = styled.div`
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    position: absolute;
    top: 0;
    left: 0;
    transform: rotateY(180deg); /* Rotate the back side */
    background: #f9f9f9;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px;
`;
export const BackHeader = styled.div`
    text-align: center;
    font-size: 1.5rem;
    font-weight: bold;
    color: #333;
    margin-bottom: 5px;
`;

export const DetailsList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

export const DetailItem = styled.li`
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 1rem;
    color: #555;

    svg {
        font-size: 1.2rem;
        color: #888;
    }

    strong {
        font-weight: 600;
        color: #333;
    }
`;

export const CircularButton = styled.button`
    align-self: center;
    background: #333;
    color: #fff;
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;
    cursor: pointer;
    transition: background 0.3s;

    &:hover {
        background: #555;
    }
`;
export const BackDetails = styled.div`
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    text-align: center;
`;
export const TalentCardHeader = styled.div`
    position: relative;
`;

export const CardHeart = styled.div<{ isActive: boolean }>`
    position: absolute;
    background-color: ${({ isActive }) => (isActive ? "#FF0D41" : "#ffffff")};
    display: inline-block;
    height: 12px;
    width: 12px;
    transform: rotate(-45deg);
    right: 1.5rem;
    top: 1.5rem;
    cursor: pointer;

    &:before,
    &:after {
        content: "";
        background-color: ${({ isActive }) =>
            isActive ? "#FF0D41" : "#ffffff"};
        border-radius: 50%;
        height: 12px;
        position: absolute;
        width: 12px;
    }

    &:before {
        top: -6px;
        left: 0;
    }

    &:after {
        left: 5.5px;
        top: 0;
    }
`;

export const ImgSection = styled.div<{ img?: string }>`
    max-width: 100%;
    height: 224px;
    background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0.1) 0%,
            rgba(0, 0, 0, 0.83) 100%
        ),
        url(${({ img }) => img && img});

    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    user-select: none;
    position: relative;
    background-size: cover;
`;

export const ImgOverlaySection = styled.div`
    padding: 10px;
    position: absolute;
    bottom: 0;
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
`;

export const TalentCardBody = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px 10px;
`;

export const CountryIcon = styled.img`
    margin-right: 10px;
`;

export const Stat = styled.div<{ marginRight?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    position: relative;

    ${({ marginRight }) =>
        marginRight &&
        css`
            &::after {
                content: "";
                position: absolute;
                width: 1px;
                background-color: #efefef;
                height: 90%;
                right: -22px;
            }
        `}
`;

export const ViewProfileButton = styled(Button)`
    padding: 12px 15px;
`;
